interface ComputerWithPersonAndMessageBubbleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithPersonAndMessageBubbleSVG = ({
  color,
  style,
}: ComputerWithPersonAndMessageBubbleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="52"
    viewBox="0 0 55 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_46523)">
      <path
        d="M21.7707 27.7333C21.7707 30.2871 19.7196 32.3555 17.1873 32.3555C14.655 32.3555 12.604 30.2871 12.604 27.7333V25.4222C12.604 22.8684 14.655 20.8 17.1873 20.8C19.7196 20.8 21.7707 22.8684 21.7707 25.4222V27.7333Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M32.0832 46.2222H22.9165"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M20.6252 46.2222H1.146V47.3778C1.146 49.296 2.68141 50.8445 4.5835 50.8445H50.4168C52.3189 50.8445 53.8543 49.296 53.8543 47.3778V46.2222H34.3752"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.7708 11.5555H6.875C4.97292 11.5555 3.4375 13.104 3.4375 15.0222V42.7555"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M51.5625 42.7556V24.2667"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M3.4375 16.1778H21.7708"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M53.8543 3.46669C53.8543 2.19558 52.8231 1.15558 51.5627 1.15558H27.5002C26.2397 1.15558 25.2085 2.19558 25.2085 3.46669V18.4889C25.2085 19.76 26.2397 20.8 27.5002 20.8H30.9377V27.7334H32.0835L37.8127 20.8H51.5627C52.8231 20.8 53.8543 19.76 53.8543 18.4889V3.46669Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M37.8125 8.08887H48.125"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M30.9375 8.08887H35.5208"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M30.9375 13.8666H40.1042"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.396 13.8666H44.6877"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.021 42.7556V40.4445C8.021 38.5262 9.55641 36.9778 11.4585 36.9778H22.9168C24.8189 36.9778 26.3543 38.5262 26.3543 40.4445V42.7556"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_46523">
        <rect width="55" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithPersonAndMessageBubbleSVG;
